import QuoteRepository from './QuoteRepository'
import AuthRepository from './AuthRepository'
import ProductRepository from './ProductRepository'
import StatsRepository from './StatsRepository'
import UserRepository from './UserRepository'


const repositories = {
  quotes: QuoteRepository,
  auth: AuthRepository,
  products: ProductRepository,
  stats: StatsRepository,
  user: UserRepository
}

export const RepositoryFactory = {
  get: name => repositories[name]
}
